import { Component, OnInit, OnChanges, ViewChild, Input, Output, TemplateRef} from '@angular/core';
import { ActionParams } from '../_models/actions';
import { SubmissionParams } from '../_models/session';
import { SearchComponent } from '../shared/search/search.component';
import { ClientDataHelper } from '../_helpers/client-data-helper';

import { Router } from '@angular/router';
import { FeatureHelperService } from '../_helpers/feature-helper/feature-helper.service';
import { AuthenticationStateHelperService } from '../_helpers/authentication-state-helper/authentication-state-helper.service';
import { FeatureSwitchService } from '../_services/feature-switch/feature-switch.service';
import { FeatureSwitchKeys } from '../_constants/feature-switch-keys';

@Component({
    selector: 'action-main',
    templateUrl: 'actions.main.component.html',
    styleUrls: ['actions.main.component.css'],
    standalone: false
})

export class ActionMainComponent implements OnInit, OnChanges{
  @ViewChild(SearchComponent, { static: false }) searchComp;
  @ViewChild('utilityBarForm', { static: true }) utilityBarForm: TemplateRef<any>;
  @Output() filteredData: any = []
  actionDataParams: ActionParams = new ActionParams();
  submissionParams: SubmissionParams = null;
  currDate: string = '';
  panelOpenState: boolean = false;
  searchData: string = "actionSearch";
  /** The filters.actions switch, handed to the search component's `filtersEnabled` input. */
  filtersEnabled: boolean = false;
  /** The search.autocomplete.actions switch, handed to the search component's utocompleteEnabled input. */
  autocompleteEnabled: boolean = false;
  constructor(
    private clientDataHelper: ClientDataHelper,
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService,
    private featureSwitches: FeatureSwitchService
    ) {}

  ngOnInit() {
    this.featureSwitches.isEnabled(FeatureSwitchKeys.filtersActions)
      .subscribe(enabled => this.filtersEnabled = enabled);
    this.featureSwitches.isEnabled(FeatureSwitchKeys.searchAutocompleteActions)
      .subscribe(enabled => this.autocompleteEnabled = enabled);

    let featureList = new Array<string>();
    featureList.push("ActionsView");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "ActionsView")[0].enabled) {
      console.error("User does not have the required permissions to view the actions screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    let clientData = this.clientDataHelper.getData(this.searchData);
    // `! clientData == null` parses as `(!clientData) == null`, which is false for every input, so
    // the panel never opened and a saved filter stayed applied but hidden. Same slip as bug 37019.
    if (clientData != null) {
      this.panelOpenState = true;
    }
  }

  ngOnChanges() {
  }

  public onSearched(data: any): void {
    this.submissionParams = data;
    this.submissionParams.onSearched = true;
    this.currDate = new Date().toString();
  }

  public onFiltered(data: any): void {
    this.filteredData = data;
  }

  public onClick() {
    let clientData = this.clientDataHelper.getData(this.searchData);
    if (clientData == null) {
      this.panelOpenState = true;
      if (!this.panelOpenState) {
        //this.searchComp.resetFilter();
      }
    }
  }
}
